if (!customElements.get('variant-selects-custom')) {
  // Static storage for component state by section ID
  const componentState = new Map();

    let smileConfigCache = null; // cache so we don't re-fetch every time

async function getSmilePointsForPrice(priceEuros) {
  try {
    if (!smileConfigCache) {
      const smileInit = document.querySelector('.smile-shopify-init');
      if (!smileInit?.dataset?.channelKey) return null;

      const channelKey = smileInit.dataset.channelKey;
      const headers = new Headers({
        'Accept': 'application/json',
        'Smile-Channel-Key': channelKey,
        'Smile-Client': 'smile-shopify-app-extensions',
        'Content-Type': 'application/json',
      });

      const programRes = await fetch(
        `https://platform.smile.io/shopify_extensions/init/points_on_product_page?channel_key=${channelKey}`,
        { method: 'GET', headers }
      );
      const programData = await programRes.json();
      
      // Log so we can see the actual field names
      console.log('Smile programData:', JSON.stringify(programData, null, 2));

      const rulesRes = await fetch(
        `https://platform.smile.io/shopify_extensions/activity_rules?account_id=${programData.account.id}`,
        { method: 'GET', headers }
      );
      const rulesData = await rulesRes.json();
      
      // Log so we can see actual field names
      console.log('Smile rulesData:', JSON.stringify(rulesData, null, 2));

      const orderRule = rulesData.activity_rules.find(rule =>
        rule.type === 'shopify_online_order' && rule.is_enabled
      );

      smileConfigCache = orderRule || null;
    }

    if (!smileConfigCache) return null;

    console.log('smileConfigCache:', JSON.stringify(smileConfigCache, null, 2));

    if (smileConfigCache.reward_value_type === 'fixed') {
      return smileConfigCache.reward_points;
    } else {
      // Log all possible multiplier field names
const rate = smileConfigCache.multiplier
  ?? smileConfigCache.points_multiplier 
  ?? smileConfigCache.reward_points_multiplier
  ?? smileConfigCache.pointsMultiplier
  ?? smileConfigCache.points_rate
  ?? smileConfigCache.rewardPointsMultiplier;
      
      console.log('rate:', rate, 'priceEuros:', priceEuros);
      return Math.floor(priceEuros * rate);
    }
  } catch (e) {
    console.error('Smile points fetch failed', e);
    return null;
  }
}

function updateSmilePointsDisplay(newPoints) {
  if (!newPoints || isNaN(newPoints)) return;
  
  const smileSection = document.querySelector('[id*="smile_io_smile_points_on_product_page"] section');
  if (!smileSection) return;

  const formatted = newPoints >= 1000
    ? Math.floor(newPoints / 1000) + '&nbsp;' + String(newPoints % 1000).padStart(3, '0')
    : String(newPoints);

  // Match both "1&nbsp;699" and "1699" formats
  smileSection.innerHTML = smileSection.innerHTML
    .replace(/\d+&nbsp;\d+(?=\s*π)/, formatted)
    .replace(/\b\d{4,6}\b(?=\s*π)/, formatted);
}

  customElements.define(
      'variant-selects-custom',
      class VariantSelectsCustom extends HTMLElement {
        constructor() {
          super();
          this.variantsData = null;
          this.selectedValues = [];
          this.currentProductHandle = null;
          this._updateUIDebounceTimer = null;

          // Get or create state for this section
          const sectionId = this.dataset.section;
          if (!componentState.has(sectionId)) {
            componentState.set(sectionId, {
              variantIndex: new Map(), // variantKey -> handle
              handlesCache: new Set(), // cached handles to avoid duplicates
              colorImageMap: new Map() // color value (normalized) -> image URL
            });
          }

          this.state = componentState.get(sectionId);
        }

        /**
         * Debounced UI update to avoid excessive DOM operations
         */
        debouncedUpdateUI() {
          if (this._updateUIDebounceTimer) {
            clearTimeout(this._updateUIDebounceTimer);
          }
          this._updateUIDebounceTimer = setTimeout(() => {
            this.hideUnavailableColorOptions();
            this.updateColorSwatchImages();
            this.updateAvailableOptions();
            this._updateUIDebounceTimer = null;
          }, 50);
        }

        connectedCallback() {
          // Guard cartUpdate payload to avoid missing sections crashes in cart drawer
          if (!window.__variantCustomCartGuardApplied && window.FoxTheme?.pubsub) {
            window.__variantCustomCartGuardApplied = true;
            const originalPublish = FoxTheme.pubsub.publish.bind(FoxTheme.pubsub);
            FoxTheme.pubsub.publish = (eventName, payload) => {
              if (eventName === FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate && payload?.cart) {
                payload.cart.sections = payload.cart.sections || {};
              }
              return originalPublish(eventName, payload);
            };
          }

          // Subscribe to cart updates to ensure cart drawer updates properly
          if (!this.cartUpdateUnsubscriber && window.FoxTheme?.pubsub) {
            this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
                FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
                this.handleCartUpdate.bind(this)
            );
          }

          // Ensure cart drawer section is included in cart:grouped-sections event
          this.cartGroupedSectionsHandler = this.handleCartGroupedSections.bind(this);
          document.addEventListener('cart:grouped-sections', this.cartGroupedSectionsHandler);

          if (this.hasAttribute('data-initialized')) {
            this.loadVariantsData();
            this.initializeSelectedValues();
            this.addEventListener('change', this.handleChange.bind(this));
            return;
          }

          this.setAttribute('data-initialized', 'true');
          this.loadVariantsData();
          this.initializeSelectedValues();
          this.addEventListener('change', this.handleChange.bind(this));

          // Load all products with the same tag and populate variantIndex
          this.loadAllProductsWithTag();
        }

        /**
         * Executes GraphQL query to Storefront API
         * @param {string} query - GraphQL query string
         * @param {Object} variables - GraphQL variables
         * @returns {Promise<Object>} - GraphQL response
         */
        async executeStorefrontQuery(query, variables = {}) {
          const shopDomain = window.shopUrl?.replace(/^https?:\/\//, '') || window.location.hostname;
          const accessToken = this.dataset.storefrontAccessToken || window.FoxTheme?.storefrontAccessToken;

          if (!accessToken) {
            throw new Error('Storefront API access token is required');
          }

          const apiUrl = `https://${shopDomain}/api/2026-01/graphql.json`;

          const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': accessToken
            },
            body: JSON.stringify({ query, variables })
          });

          if (!response.ok) {
            throw new Error(`Storefront API error: ${response.status}`);
          }

          const data = await response.json();
          if (data.errors) {
            throw new Error(`GraphQL errors: ${JSON.stringify(data.errors)}`);
          }

          return data.data;
        }

        /**
         * Searches products by tag using Storefront API
         * @param {string} tag - product tag to search
         * @param {number} first - number of products to fetch
         * @param {string} after - cursor for pagination
         * @returns {Promise<Object>} - products data
         */
        async searchProductsByTag(tag, first = 50, after = null) {
          const query = `
            query searchProductsByTag($query: String!, $first: Int!, $after: String) {
              products(first: $first, after: $after, query: $query) {
                edges {
                  node {
                    id
                    handle
                    title
                    featuredImage {
                      url
                    }
                    images(first: 1) {
                      edges {
                        node {
                          url
                        }
                      }
                    }
                    tags
                    metafield(namespace: "suppliers_app", key: "variants") {
                      value
                      type
                    }
                  }
                  cursor
                }
                pageInfo {
                  hasNextPage
                  endCursor
                }
              }
            }
          `;

          const variables = {
            query: `tag:${tag}`,
            first,
            after
          };

          return await this.executeStorefrontQuery(query, variables);
        }

        /**
         * Gets unique colors from variants data
         * @returns {Set<string>} - set of normalized color values
         */
        getUniqueColors() {
          const colorIndex = this.getColorAttributeIndex();
          if (colorIndex === -1 || !this.variantsData || !Array.isArray(this.variantsData.variants)) {
            return new Set();
          }

          const uniqueColors = new Set();
          this.variantsData.variants.forEach(variant => {
            const colorValue = variant?.[colorIndex];
            if (colorValue) {
              uniqueColors.add(this.normalizeColorValue(colorValue));
            }
          });
          return uniqueColors;
        }

        /**
         * Checks if all colors have images
         * @param {Set<string>} uniqueColors - set of color values
         * @returns {boolean}
         */
        allColorsHaveImages(uniqueColors) {
          if (uniqueColors.size === 0) return true;
          for (const colorKey of uniqueColors) {
            if (!this.state.colorImageMap.has(colorKey)) {
              return false;
            }
          }
          return true;
        }

        /**
         * Extracts image URL from Storefront API product node
         * @param {Object} productNode - product node from Storefront API
         * @returns {string|null} - image URL or null
         */
        extractImageFromStorefrontNode(productNode) {
          if (productNode.featuredImage?.url) {
            return productNode.featuredImage.url;
          }
          if (productNode.images?.edges?.length > 0) {
            return productNode.images.edges[0].node.url;
          }
          return null;
        }

        /**
         * Loads all products with the same tag and populates variantIndex and colorImageMap
         * Optimized to load both in a single pass
         */
        async loadAllProductsWithTag() {
          const variantTag = this.dataset.variantTag;
          if (!variantTag) return;

          const colorIndex = this.getColorAttributeIndex();
          const uniqueColors = this.getUniqueColors();
          const needsColorImages = colorIndex !== -1 && uniqueColors.size > 0 && !this.allColorsHaveImages(uniqueColors);

          // Early exit if we have all color images already
          if (colorIndex !== -1 && !needsColorImages) {
            this.hideUnavailableColorOptions();
            this.updateColorSwatchImages();
            this.updateAvailableOptions();
            return;
          }

          try {
            let hasNextPage = true;
            let cursor = null;
            const processedHandles = new Set();
            const BATCH_SIZE = 10; // Increased batch size for better performance
            const MAX_ITERATIONS = 20; // Increased limit
            let iteration = 0;

            while (hasNextPage && iteration < MAX_ITERATIONS) {
              const result = await this.searchProductsByTag(variantTag, 50, cursor);
              if (!result?.products?.edges) break;
              const products = result.products.edges.map(edge => edge.node);
              const newHandles = products
                  .map(p => p.handle)
                  .filter(h => !processedHandles.has(h) && !this.state.handlesCache.has(h));

              if (newHandles.length === 0) {
                hasNextPage = result.products.pageInfo.hasNextPage;
                cursor = result.products.pageInfo.endCursor;
                iteration++;
                continue;
              }

              // Process products in parallel batches
              for (let i = 0; i < newHandles.length; i += BATCH_SIZE) {
                const batch = newHandles.slice(i, i + BATCH_SIZE);
                const batchPromises = batch.map(async (h) => {
                  processedHandles.add(h);
                  this.state.handlesCache.add(h);

                  // Get product node from Storefront API result
                  const productNode = products.find(p => p.handle === h);
                  if (!productNode) {
                    // Fallback to loadProductData if product not found in result
                    return this.loadProductData(h);
                  }

                  // Try to use metafield data from Storefront API
                  if (productNode.metafield?.value) {
                    const imageUrl = this.extractImageFromStorefrontNode(productNode);
                    const productData = this.processProductFromMetafield(h, productNode.metafield, imageUrl);
                    if (productData) {
                      return productData;
                    }
                  }

                  // Fallback to loadProductData if metafield is not available
                  return this.loadProductData(h);
                });

                await Promise.all(batchPromises);

                // Early exit if we have all colors now
                if (needsColorImages && this.allColorsHaveImages(uniqueColors)) {
                  hasNextPage = false;
                  break;
                }
              }

              hasNextPage = result.products.pageInfo.hasNextPage;
              cursor = result.products.pageInfo.endCursor;
              iteration++;
            }

            // Update UI once after all loading is complete
            this.debouncedUpdateUI();

            // Log final variantIndex state
            // console.log('[variant-selects-custom] variantIndex filled after loadAllProductsWithTag:', {
            //   size: this.state.variantIndex.size,
            //   totalEntries: Array.from(this.state.variantIndex.entries()),
            //   variantIndexMap: Object.fromEntries(this.state.variantIndex)
            // });
          } catch (error) {
            console.error('[loadAllProductsWithTag] Error loading products:', error);
          }
        }

        disconnectedCallback() {
          if (this.cartUpdateUnsubscriber) {
            this.cartUpdateUnsubscriber();
            this.cartUpdateUnsubscriber = null;
          }
          if (this.cartGroupedSectionsHandler) {
            document.removeEventListener('cart:grouped-sections', this.cartGroupedSectionsHandler);
            this.cartGroupedSectionsHandler = null;
          }
        }

        /**
         * Handles cart:grouped-sections event to ensure cart drawer section is included
         * @param {CustomEvent} event - cart:grouped-sections event
         */
        handleCartGroupedSections(event) {
          if (!event.detail?.sections) return;

          // Find cart drawer and add its section ID to the list
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && cartDrawer.sectionId) {
            const sectionId = cartDrawer.sectionId;
            if (!event.detail.sections.includes(sectionId)) {
              event.detail.sections.push(sectionId);
            }
          }
        }

        /**
         * Handles cart update events to ensure cart drawer is properly updated
         * @param {Object} event - cart update event
         */
        handleCartUpdate(event) {
          if (!event?.cart) return;

          // Ensure sections object exists
          if (!event.cart.sections) {
            event.cart.sections = {};
          }

          // Check if cart drawer section is missing but cart has items
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && cartDrawer.sectionId) {
            const drawerSectionId = cartDrawer.sectionId;
            if (!event.cart.sections[drawerSectionId] && event.cart.item_count > 0) {
              // Fetch missing section and update cart
              this.fetchAndUpdateCartSection(drawerSectionId, event.cart);
            }
          }
        }

        /**
         * Fetches missing cart section and updates cart drawer
         * @param {string} sectionId - section ID to fetch
         * @param {Object} cartData - current cart data
         */
        async fetchAndUpdateCartSection(sectionId, cartData) {
          try {
            const response = await fetch(`${FoxTheme.routes.root_url}?section_id=${sectionId}`);
            if (!response.ok) return;

            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const sectionElement = doc.getElementById(`shopify-section-${sectionId}`);

            if (sectionElement) {
              // Add section to cart data
              cartData.sections[sectionId] = sectionElement.outerHTML;

              // Re-publish cart update with complete sections
              FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartData });
            }
          } catch (error) {
            console.error('Error fetching cart section:', error);
          }
        }

        /**
         * Normalizes variant array to match stored format
         * @param {Array} variant - variant array
         * @param {number} attributesLength - expected length
         * @returns {Array} - normalized variant array
         */
        normalizeVariant(variant, attributesLength) {
          const normalized = variant.map(v => (v === null || v === undefined) ? '' : v);
          while (normalized.length < attributesLength) {
            normalized.push('');
          }
          if (normalized.length > attributesLength) {
            normalized.length = attributesLength;
          }
          return normalized;
        }

        loadVariantsData() {
          const metafieldScript = this.querySelector('[data-variants-metafield]');
          if (metafieldScript) {
            try {
              this.variantsData = JSON.parse(metafieldScript.textContent);
              this.selectedValues = [...(this.variantsData.currentVariantData || [])];
            } catch (error) {
              console.error('Error parsing variants metafield:', error);
            }
          }

          // Get current product handle from DOM first, then URL
          const currentHandleFromDOM = this.getCurrentProductHandleFromDOM();
          if (currentHandleFromDOM) {
            this.currentProductHandle = currentHandleFromDOM;
          } else {
            // Fallback to URL if DOM doesn't have handle
            const urlMatch = window.location.pathname.match(/\/products\/([^/?]+)/);
            if (urlMatch) {
              const urlHandle = decodeURIComponent(urlMatch[1]);
              this.currentProductHandle = urlHandle;
            }
          }

          // Add current product's currentVariantData to variantIndex
          if (this.currentProductHandle && this.variantsData) {
            const currentVariantData = this.variantsData.currentVariantData || [];
            if (Array.isArray(currentVariantData) && currentVariantData.length > 0 && Array.isArray(this.variantsData.attributes)) {
              const normalizedVariant = this.normalizeVariant(currentVariantData, this.variantsData.attributes.length);
              const variantKey = this.createVariantKey(normalizedVariant);
              // this.state.variantIndex.set(variantKey, this.currentProductHandle);
              this.invalidateColorVariantCache();

              // console.log('[variant-selects-custom] variantIndex updated after loadVariantsData:', {
              //   size: this.state.variantIndex.size,
              //   variantKey,
              //   handle: this.currentProductHandle,
              //   variantIndex: Array.from(this.state.variantIndex.entries())
              // });
            }
          }
        }



        /**
         * Processes product data from metafield without HTTP request
         * @param {string} handle - product handle
         * @param {Object} metafield - metafield object from Storefront API
         * @param {string|null} imageUrl - image URL from Storefront API
         * @returns {Object|null} - processed product data
         */
        processProductFromMetafield(handle, metafield, imageUrl = null) {
          if (!metafield?.value) {
            return null;
          }

          try {
            const metafieldData = typeof metafield.value === 'string'
                ? JSON.parse(metafield.value)
                : metafield.value;

            const currentVariantData = metafieldData.currentVariantData || [];

            // Add this product's current variant to variantIndex
            if (Array.isArray(currentVariantData) && currentVariantData.length > 0 && Array.isArray(metafieldData.attributes)) {
              const normalizedVariant = this.normalizeVariant(currentVariantData, metafieldData.attributes.length);
              const variantKey = this.createVariantKey(normalizedVariant);
              if (!this.state.variantIndex.has(variantKey)) {
                this.state.variantIndex.set(variantKey, handle);
                this.invalidateColorVariantCache();
              }
            }

            // Build color -> image map: find one product per color value
            const colorIndex = this.getColorAttributeIndexFromAttributes(metafieldData.attributes);
            if (colorIndex !== -1 && Array.isArray(currentVariantData) && imageUrl) {
              const colorValue = currentVariantData[colorIndex];

              if (colorValue) {
                const colorKey = this.normalizeColorValue(colorValue);

                // Only add if we don't have an image for this color yet
                if (!this.state.colorImageMap.has(colorKey)) {
                  const url = new URL(imageUrl);
                  url.searchParams.set("width", "64");

                  const thumbnailImageUrl = url.toString();
                  this.state.colorImageMap.set(colorKey, thumbnailImageUrl);
                }
              }
            }

            return { handle, metafield: metafieldData };
          } catch (err) {
            console.error(`Error processing product ${handle} from metafield:`, err);
            return null;
          }
        }

        /**
         * Extracts image URL from product data script
         * @param {Object} productData - product data object
         * @returns {string|null} - image URL or null
         */
        extractImageFromProductData(productData) {
          if (!productData) return null;

          // Try featured image first
          if (productData.featured_image) {
            if (typeof productData.featured_image === 'string') {
              return productData.featured_image;
            }
            if (productData.featured_image.src) {
              return productData.featured_image.src;
            }
          }

          // Fallback to first image from images array
          if (Array.isArray(productData.images) && productData.images.length > 0) {
            const firstImage = productData.images[0];
            if (typeof firstImage === 'string') {
              return firstImage;
            }
            if (firstImage.src) {
              return firstImage.src;
            }
            if (firstImage.url) {
              return firstImage.url;
            }
          }

          return null;
        }

        /**
         * Loads product data and builds index entry for it
         * @param {string} handle - product handle
         * @returns {Promise<Object|null>} - product data or null
         */
        async loadProductData(handle) {
          try {
            const productResponse = await fetch(`/products/${handle}?section_id=${this.dataset.section}`);
            if (!productResponse.ok) {
              return null;
            }

            // console.log('productResponse', productResponse)

            const productHtml = await productResponse.text();
            const parser = new DOMParser();
            const productDoc = parser.parseFromString(productHtml, 'text/html');
            const variantPicker = productDoc.querySelector('variant-selects-custom');

            if (!variantPicker) {
              return null;
            }

            const metafieldScript = variantPicker.querySelector('[data-variants-metafield]');
            const currentProductScript = variantPicker.querySelector('[data-current-product]');
            if (!metafieldScript) {
              return null;
            }

            const metafieldData = JSON.parse(metafieldScript.textContent);
            const currentVariantData = metafieldData.currentVariantData || [];

            // Add this product's current variant to variantIndex
            if (Array.isArray(currentVariantData) && currentVariantData.length > 0 && Array.isArray(metafieldData.attributes)) {
              const normalizedVariant = this.normalizeVariant(currentVariantData, metafieldData.attributes.length);
              const variantKey = this.createVariantKey(normalizedVariant);
              if (!this.state.variantIndex.has(variantKey)) {
                this.state.variantIndex.set(variantKey, handle);
                this.invalidateColorVariantCache();

                // // Log every 10th addition to avoid spam
                // if (this.state.variantIndex.size % 10 === 0) {
                //   console.log('[variant-selects-custom] variantIndex progress:', {
                //     size: this.state.variantIndex.size,
                //     lastAdded: { variantKey, handle }
                //   });
                // }
              }
            }

            // Build color -> image map: find one product per color value
            const colorIndex = this.getColorAttributeIndexFromAttributes(metafieldData.attributes);
            if (colorIndex !== -1 && Array.isArray(currentVariantData) && currentProductScript) {
              const colorValue = currentVariantData[colorIndex];

              if (colorValue) {
                const colorKey = this.normalizeColorValue(colorValue);

                // Only add if we don't have an image for this color yet
                if (!this.state.colorImageMap.has(colorKey)) {
                  try {
                    const productData = JSON.parse(currentProductScript.textContent);
                    const imageUrl = this.extractImageFromProductData(productData);

                    if (imageUrl) {
                      const url = new URL(imageUrl);
                      url.searchParams.set("width", "64");

                      const thumbnailImageUrl = url.toString();
                      this.state.colorImageMap.set(colorKey, thumbnailImageUrl);
                    }
                  } catch (e) {
                    console.warn('Error parsing product data for color image:', e);
                  }
                }
              }
            }

            return { handle, metafield: metafieldData };
          } catch (err) {
            console.error(`Error loading product ${handle}:`, err);
            return null;
          }
        }

        /**
         * Создает ключ для варианта из массива значений
         * @param {Array} values - массив значений варианта
         * @returns {string} - ключ варианта
         */
        createVariantKey(values) {
          if (!Array.isArray(values)) return '';

          return values.map(v => {
            if (v === null || v === undefined) return '';
            const str = String(v).toLowerCase().trim();
            return (str === 'null' || str === 'undefined') ? '' : str;
          }).join('|||');
        }

        /**
         * Нормализует значение цвета для использования как ключ
         * @param {string} value
         * @returns {string}
         */
        normalizeColorValue(value) {
          return String(value).toLowerCase().trim();
        }

        /**
         * Возвращает индекс атрибута цвета (Χρώμα / Color) из массива атрибутов
         * @param {Array} attributes - массив имен атрибутов
         * @returns {number} - индекс атрибута цвета или -1
         */
        getColorAttributeIndexFromAttributes(attributes) {
          if (!Array.isArray(attributes)) return -1;
          for (let i = 0; i < attributes.length; i++) {
            const name = String(attributes[i] || '').toLowerCase();
            if (name === 'color' || name === 'χρώμα') {
              return i;
            }
          }
          return -1;
        }

        /**
         * Возвращает индекс атрибута цвета (Χρώμα / Color) из variantsData текущего продукта
         * @returns {number} - индекс атрибута цвета или -1
         */
        getColorAttributeIndex() {
          if (!this.variantsData || !Array.isArray(this.variantsData.attributes)) return -1;
          return this.getColorAttributeIndexFromAttributes(this.variantsData.attributes);
        }

        /**
         * Обновляет отображение свотчей цвета картинками продуктов
         */
        /**
         * Cached color index for faster lookups
         * @type {Map<string, Set<string>>|null}
         */
        _colorVariantCache = null;

        /**
         * Builds cache of colors to variant keys for faster lookups
         */
        buildColorVariantCache() {
          if (this._colorVariantCache !== null) return;

          const colorIndex = this.getColorAttributeIndex();
          if (colorIndex === -1) {
            this._colorVariantCache = new Map();
            return;
          }

          this._colorVariantCache = new Map();
          const normalizedColorValue = this.normalizeColorValue.bind(this);

          for (const variantKey of this.state.variantIndex.keys()) {
            const variantValues = variantKey.split('|||');
            const colorValue = variantValues[colorIndex];
            if (colorValue) {
              const colorKey = normalizedColorValue(colorValue);
              if (!this._colorVariantCache.has(colorKey)) {
                this._colorVariantCache.set(colorKey, new Set());
              }
              this._colorVariantCache.get(colorKey).add(variantKey);
            }
          }
        }

        /**
         * Invalidates color variant cache
         */
        invalidateColorVariantCache() {
          this._colorVariantCache = null;
        }

        // /**
        //  * Checks if color value exists in variantIndex
        //  * @param {string} colorValue - color value to check
        //  * @param {number} colorIndex - index of color attribute
        //  * @returns {boolean} - true if variant with this color exists
        //  */
        // hasColorInVariantIndex(colorValue, colorIndex) {
        //   if (this.state.variantIndex.size === 0) return false;
        //
        //   this.buildColorVariantCache();
        //   const colorKey = this.normalizeColorValue(colorValue);
        //   return this._colorVariantCache.has(colorKey) && this._colorVariantCache.get(colorKey).size > 0;
        // }

        /**
         * Disables color options that don't exist in variantIndex
         * Only disables if variantIndex has been populated (has at least one entry)
         */
        hideUnavailableColorOptions() {
          const colorIndex = this.getColorAttributeIndex();
          if (colorIndex === -1) return;

          // Only disable if variantIndex has been populated
          if (this.state.variantIndex.size === 0) {
            return;
          }

          // Find all inputs for color attribute within this component
          const inputs = this.querySelectorAll(`input[type="radio"][data-attribute-index="${colorIndex}"]`);
          if (inputs.length === 0) return;

          // Build cache once for all checks
          this.buildColorVariantCache();

          inputs.forEach((input) => {
            const value = input.value;
            if (!value) return;

            // Check if this color exists in variantIndex (using cache)
            const colorKey = this.normalizeColorValue(value);
            const hasVariant = this._colorVariantCache.has(colorKey) &&
                this._colorVariantCache.get(colorKey).size > 0;

            // Find label and fieldset wrapper (cache lookup)
            const label = document.querySelector(`label[for="${input.id}"][data-swatch-type="image"]`);
            if (!label) return;

            const fieldset = input.closest('fieldset, div.product-form__input');

            // Disable input and label if variant doesn't exist
            if (!hasVariant) {
              const isSelected = input.checked;
              // Only disable if not selected
              if (!isSelected) {
                input.setAttribute('disabled', 'disabled');
                input.classList.add('disabled');
                label.classList.add('disabled');
              }
            } else {
              // Enable input and label if variant exists
              input.removeAttribute('disabled');
              input.classList.remove('disabled');
              label.classList.remove('disabled');
            }
          });
        }

        updateColorSwatchImages() {
          const colorIndex = this.getColorAttributeIndex();
          if (colorIndex === -1) return;
          if (!this.state.colorImageMap || this.state.colorImageMap.size === 0) return;

          // Find all inputs for color attribute within this component
          const inputs = this.querySelectorAll(`input[type="radio"][data-attribute-index="${colorIndex}"]`);
          if (inputs.length === 0) return;

          inputs.forEach((input) => {
            const value = input.value;
            if (!value) return;

            const colorKey = this.normalizeColorValue(value);

            //console.log('this.state.colorImageMap', this.state.colorImageMap)
            const imageUrl = this.state.colorImageMap.get(colorKey);

            if (!imageUrl) return;

            // Find label by for attribute - search in document, not just this component
            const label = document.querySelector(`label[for="${input.id}"][data-swatch-type="image"]`);
            if (!label) return;

            // Find or create image element
            let img = label.querySelector('img');
            if (!img) {
              img = document.createElement('img');
              img.className = 'object-cover w-16 h-16';
              img.width = 64;
              img.height = 64;
              img.loading = 'lazy';
              img.alt = value;
              label.insertBefore(img, label.firstChild);
            }

            // Hide text color name when image is available
            const colorNameEl = label.querySelector('[data-color-name]');
            if (colorNameEl) {
              colorNameEl.style.display = 'none';
            }

            // Update image src if different (avoid unnecessary updates)
            const currentSrc = img.getAttribute('src');
            if (currentSrc !== imageUrl) {
              img.src = imageUrl;
            }
          });
        }

        /**
         * Gets current product handle from DOM
         * @returns {string|null} - product handle from DOM or null
         */
        getCurrentProductHandleFromDOM() {
          const currentProductScript = this.querySelector('[data-current-product]');
          if (currentProductScript) {
            try {
              const productData = JSON.parse(currentProductScript.textContent);
              return productData?.handle || null;
            } catch (e) {
              console.warn('Error parsing current product data:', e);
            }
          }
          return null;
        }

        /**
         * Finds product handle by variant combination
         * @param {Array} selectedValues - selected values
         * @returns {string|null} - found product handle or null
         */
        findHandleByVariant(selectedValues) {
          // console.log('[variant-selects-custom]>>++++ findHandleByVariant called with selectedValues:', selectedValues);
          if (!selectedValues || selectedValues.length === 0) return null;

          // Normalize variant array to match stored format
          const attributesLength = this.variantsData?.attributes?.length || 0;
          if (attributesLength === 0) return null;

          const normalizedVariant = this.normalizeVariant(selectedValues, attributesLength);
          const variantKey = this.createVariantKey(normalizedVariant);
          const handle = this.state.variantIndex.get(variantKey) || null;

          // if (handle) {
          //   console.log('[variant-selects-custom] findHandleByVariant found:', {
          //     variantKey,
          //     handle,
          //     variantIndexSize: this.state.variantIndex.size
          //   });
          // }

          return handle;
        }


        initializeSelectedValues() {
          if (!this.variantsData) return;

          const fieldsets = this.querySelectorAll('fieldset, div.product-form__input');
          fieldsets.forEach((fieldset, index) => {
            const attributeIndex = parseInt(fieldset.dataset.attributeIndex || index);
            if (this.selectedValues[attributeIndex]) {
              this.updateSelectedValueDisplay(fieldset, this.selectedValues[attributeIndex]);
            }
          });

          // Update available options after initializing selected values
          this.updateAvailableOptions();

          // Don't hide options yet - show all colors initially
          // hideUnavailableColorOptions() will be called after variantIndex is populated

          // Update color swatch images if available
          this.updateColorSwatchImages();
        }

        handleChange(event) {
          const target = this.getInputForEventTarget(event.target);
          if (!target) return;

          const attributeIndex = parseInt(target.dataset.attributeIndex);
          const value = target.value;

          if (attributeIndex !== undefined && this.selectedValues) {
            this.selectedValues[attributeIndex] = value;
            this.updateSelectedValueDisplay(target.closest('fieldset, div.product-form__input'), value);
            this.updateAvailableOptions();
            this.findAndUpdateMatchingProduct();
          }
        }

        getInputForEventTarget(target) {
          if (target.tagName === 'SELECT') {
            return target.selectedOptions[0];
          }
          if (target.tagName === 'INPUT' && target.type === 'radio') {
            return target;
          }
          return target;
        }

        updateSelectedValueDisplay(fieldset, value) {
          if (!fieldset) return;

          const selectedValueElement = fieldset.querySelector('[data-selected-value]');
          if (selectedValueElement) {
            selectedValueElement.textContent = value;
          }

          // Update radio button checked state
          const inputs = fieldset.querySelectorAll('input[type="radio"]');
          inputs.forEach((input) => {
            input.checked = input.value === value;
          });

          // Update select selected state
          const select = fieldset.querySelector('select');
          if (select) {
            Array.from(select.options).forEach((option) => {
              option.selected = option.value === value;
            });
          }
        }

        async findAndUpdateMatchingProduct() {
          if (!this.variantsData || !this.selectedValues.length) return;

          // Normalize selected values to match stored format
          const attributesLength = this.variantsData?.attributes?.length || 0;
          const normalizedSelectedValues = this.normalizeVariant(this.selectedValues, attributesLength);

          // console.log('[variant-selects-custom]>> selected variant values:', {
          //   selectedValues: this.selectedValues,
          //   normalizedSelectedValues,
          //   attributes: this.variantsData.attributes
          // });

          // Check index for exact match
          let handle = this.findHandleByVariant(normalizedSelectedValues);

          // console.log('[variant-selects-custom] handle from variantIndex:', handle);

          // If not found in index, try lazy load
          if (!handle) {
            // console.log('[variant-selects-custom] handle not found in index, trying lazy load...');
            handle = await this.findHandleByVariantLazy(normalizedSelectedValues);
            // console.log('[variant-selects-custom] handle from lazy load:', handle);
          }

          // Get current handle from DOM to ensure accuracy
          const currentHandleFromDOM = this.getCurrentProductHandleFromDOM();
          const currentHandle = currentHandleFromDOM || this.currentProductHandle;

          // console.log('>>>>>', handle, '--------', currentHandle, 'DOM:', currentHandleFromDOM, 'stored:', this.currentProductHandle);

          // Navigate to product if different handle found
          if (handle && handle !== currentHandle) {
            // console.log('[variant-selects-custom] selected variant handle:', {
            //   handle,
            //   currentHandle: currentHandle,
            //   currentHandleFromDOM: currentHandleFromDOM,
            //   storedHandle: this.currentProductHandle,
            //   variantKey: this.createVariantKey(normalizedSelectedValues)
            // });
            await this.navigateToProductHandle(handle);
          } else {
            // Same product or not found - update variant data
            // console.log('[variant-selects-custom] ????? same product or handle not found:', {
            //   handle,
            //   currentHandle: currentHandle,
            //   currentHandleFromDOM: currentHandleFromDOM,
            //   storedHandle: this.currentProductHandle,
            //   willUpdateVariantData: true
            // });
            this.updateCurrentProductVariantData();
          }
        }

        /**
         * Lazy loads product handle by searching through variant tag products using Storefront API
         * @param {Array} selectedValues - selected variant values
         * @returns {Promise<string|null>} - product handle or null
         */
        async findHandleByVariantLazy(selectedValues) {
          // console.log('[variant-selects-custom] findHandleByVariantLazy called with selectedValues:', selectedValues);
          const variantTag = this.dataset.variantTag;
          if (!variantTag) return null;

          const variantKey = this.createVariantKey(selectedValues);
          const processedHandles = new Set();

          try {
            let hasNextPage = true;
            let cursor = null;
            const MAX_ITERATIONS = 15; // Increased limit
            const BATCH_SIZE = 10; // Increased batch size

            let iteration = 0;
            while (hasNextPage && iteration < MAX_ITERATIONS) {
              const result = await this.searchProductsByTag(variantTag, 100, cursor);

              if (!result?.products?.edges) break;

              const products = result.products.edges.map(edge => edge.node);
              const newHandles = products
                  .map(p => p.handle)
                  .filter(h => !processedHandles.has(h) && !this.state.handlesCache.has(h));

              if (newHandles.length === 0) {
                hasNextPage = result.products.pageInfo.hasNextPage;
                cursor = result.products.pageInfo.endCursor;
                iteration++;
                continue;
              }

              // Load products in parallel batches
              for (let i = 0; i < newHandles.length; i += BATCH_SIZE) {
                const batch = newHandles.slice(i, i + BATCH_SIZE);
                const batchPromises = batch.map(h => {
                  processedHandles.add(h);
                  this.state.handlesCache.add(h);

                  // Get product node from Storefront API result
                  const productNode = products.find(p => p.handle === h);
                  if (!productNode) {
                    // Fallback to loadProductData if product not found in result
                    return this.loadProductData(h);
                  }

                  // Try to use metafield data from Storefront API
                  if (productNode.metafield?.value) {
                    const imageUrl = this.extractImageFromStorefrontNode(productNode);
                    const productData = this.processProductFromMetafield(h, productNode.metafield, imageUrl);
                    if (productData) {
                      return Promise.resolve(productData);
                    }
                  }

                  // Fallback to loadProductData if metafield is not available
                  return this.loadProductData(h);
                });
                await Promise.all(batchPromises);

                // Check if we found the variant (early exit)
                if (this.state.variantIndex.has(variantKey)) {
                  const foundHandle = this.state.variantIndex.get(variantKey);
                  // console.log('[variant-selects-custom] findHandleByVariantLazy found handle:', {
                  //   variantKey,
                  //   handle: foundHandle,
                  //   iteration,
                  //   batchNumber: Math.floor(i / BATCH_SIZE) + 1
                  // });
                  return foundHandle;
                }
              }

              hasNextPage = result.products.pageInfo.hasNextPage;
              cursor = result.products.pageInfo.endCursor;
              iteration++;
            }
          } catch (error) {
            console.error('Error finding handle by variant lazy:', error);
          }

          return null;
        }

        /**
         * Loads and updates product by handle without page reload
         * @param {string} handle - product handle
         */
        async navigateToProductHandle(handle) {
  if (!handle) return;

  try {
    const response = await fetch(`/products/${handle}?section_id=${this.dataset.section}`);
    if (!response.ok) {
      console.error('Failed to fetch product:', response.status);
      return;
    }

    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const newProductInfo = doc.querySelector(`product-info[id^="MainProduct-${this.dataset.section}"]`);
    const currentProductInfo = document.querySelector(`product-info[id^="MainProduct-${this.dataset.section}"]`);
    // const newStickyAtc = doc.getElementById('shopify-section-sticky-atc-bar');
    // const currentStickyAtc = document.getElementById('shopify-section-sticky-atc-bar');

    if (!newProductInfo || !currentProductInfo) {
      console.warn('Product info not found in response or current page');
      return;
    }

    // ✅ Save fbr BEFORE swap — it lives inside media-gallery which gets replaced
    const fbrContainer = document.querySelector('.fbr-visual-recommendations-container');
    const fbrClone = fbrContainer ? fbrContainer.cloneNode(true) : null;

    const blockSelectors = [
      'pdp-media-gallery',
      '.product__blocks-below-media',
      '.pdp-info__block--badges',
      '.pdp-info__block--title',
      '.pdp-info__block--meta',
      '.pdp-info__block--price',
      '.pdp-info__block--inventory',
      '.pdp-info__block--variant_picker_custom',
      '[id*="__warranties_warranties"]',
      '.pdp-info__block--buy_buttons',
      '.pdp-info__block--grid-icon-box',
      '.pdp-info__block--pickup_availability',
      '.product__media-tabs',
    ];

    // Swap blocks
    blockSelectors.forEach(selector => {
      const newBlocks = newProductInfo.querySelectorAll(selector);
      const currentBlocks = currentProductInfo.querySelectorAll(selector);
      newBlocks.forEach((newBlock, i) => {
        if (currentBlocks[i]) {
          currentBlocks[i].outerHTML = newBlock.outerHTML;
        }
      });
    });

    // ✅ Restore fbr widget AFTER swap with updated product ID
    const newProductId = doc.querySelector('[data-product-id]')?.dataset?.productId;
    const newFbrTarget = document.querySelector('.product__media-gallery-viewer-wrap');

    if (fbrClone && newFbrTarget) {
      const fbrSpan = fbrClone.querySelector('.fbr-visual-recommendations[data-document-id]');
      if (fbrSpan && newProductId) {
        fbrSpan.setAttribute('data-document-id', newProductId);
      }
      newFbrTarget.appendChild(fbrClone);
    }
    // Update sticky ATC bar
    // if (newStickyAtc && currentStickyAtc) {
    //   if (window.HTMLUpdateUtility?.viewTransition) {
    //     window.HTMLUpdateUtility.viewTransition(currentStickyAtc, newStickyAtc, [], []);
    //   } else {
    //     currentStickyAtc.outerHTML = newStickyAtc.outerHTML;
    //   }
    // }

    // Update URL
    const url = new URL(window.location.href);
    url.pathname = `/el-gr/products/${handle}`;
    url.search = '';
    window.history.pushState({}, '', url.toString());

    this.currentProductHandle = handle;
    this.updateVariantsFromDOM();

    await new Promise(resolve => setTimeout(resolve, 0));

    const updatedProductInfo = document.querySelector(`product-info[id^="MainProduct-${this.dataset.section}"]`);

    if (updatedProductInfo?.resetProductFormState) {
      updatedProductInfo.resetProductFormState();
    }

    if (updatedProductInfo) {
      const variantSelects = updatedProductInfo.querySelector('variant-selects [data-selected-variant]');
      const variant = variantSelects ? JSON.parse(variantSelects.innerHTML) : null;

      if (variant) {
        document.dispatchEvent(new CustomEvent('variant:changed', {
          detail: { variant }
        }));

        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId: this.dataset.section,
            html: doc,
            variant,
          },
        });
      }
    }

    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
      data: {
        event: new Event('change'),
        target: this,
        selectedOptionValues: this.selectedValues,
        isCustomVariant: true,
      },
    });

    await new Promise(resolve => setTimeout(resolve, 100));

    const productForm = updatedProductInfo?.querySelector('form[is="product-form"]');
    if (productForm && !productForm.hasAttribute('data-variant-custom-initialized')) {
      productForm.setAttribute('data-variant-custom-initialized', 'true');
    }

    this.debouncedUpdateUI();

    const selectedVariantScript = doc.querySelector('[data-selected-variant]');
if (selectedVariantScript) {
  try {
    const variantData = JSON.parse(selectedVariantScript.textContent);
    console.log('variantData price:', variantData?.price);
    if (variantData?.price) {
      const points = await getSmilePointsForPrice(variantData.price / 100);
      console.log('calculated points:', points);
      if (points !== null) updateSmilePointsDisplay(points);
    }
  } catch(e) {
    console.error('variant parse error:', e);
  }
}

  } catch (error) {
    console.error('Error loading product:', error);
  }
}

        /**
         * Updates variant data from new DOM after product update
         */
        updateVariantsFromDOM() {
          const newVariantPicker = document.querySelector('variant-selects-custom');
          if (!newVariantPicker) return;

          const newMetafieldScript = newVariantPicker.querySelector('[data-variants-metafield]');
          if (!newMetafieldScript) return;

          try {
            const newVariantsData = JSON.parse(newMetafieldScript.textContent);
            if (newVariantsData.currentVariantData) {
              this.selectedValues = [...newVariantsData.currentVariantData];
              this.variantsData = newVariantsData;
              this.initializeSelectedValues();
            }
          } catch (e) {
            console.error('Error parsing new variants data:', e);
          }

          // Sync currentProductHandle from DOM first, then URL
          const currentHandleFromDOM = this.getCurrentProductHandleFromDOM();
          if (currentHandleFromDOM) {
            this.currentProductHandle = currentHandleFromDOM;
          } else {
            // Fallback to URL if DOM doesn't have handle
            const urlMatch = window.location.pathname.match(/\/products\/([^/?]+)/);
            if (urlMatch) {
              const urlHandle = decodeURIComponent(urlMatch[1]);
              this.currentProductHandle = urlHandle;
            }
          }
        }

        /**
         * Проверяет, доступен ли вариант с указанным значением для атрибута
         * @param {Array} allVariants - все варианты
         * @param {number} attributeIndex - индекс атрибута
         * @param {string} value - значение для проверки
         * @param {Array} selectedValues - выбранные значения
         * @returns {boolean} - доступен ли вариант
         */
        isVariantAvailable(allVariants, attributeIndex, value, selectedValues) {
          // First check if variant exists in variantsData
          const existsInVariants = allVariants.some(variant => {
            if (variant[attributeIndex] !== value) return false;

            // Проверяем соответствие другим выбранным значениям
            for (let i = 0; i < selectedValues.length; i++) {
              if (i !== attributeIndex && selectedValues[i] && variant[i] !== selectedValues[i]) {
                return false;
              }
            }
            return true;
          });

          if (!existsInVariants) return false;

          // Check if this combination exists in variantIndex (has a product)
          const testValues = [...selectedValues];
          testValues[attributeIndex] = value;

          // Normalize test values to match stored format
          const attributesLength = this.variantsData?.attributes?.length || 0;
          const normalizedTestValues = this.normalizeVariant(testValues, attributesLength);

          const variantKey = this.createVariantKey(normalizedTestValues);
          const hasProduct = this.state.variantIndex.has(variantKey);

          return hasProduct;
        }

        /**
         * Обновляет состояние disabled для input элемента
         */
        updateInputDisabledState(input, isAvailable, fieldset) {
          if (input.tagName === 'INPUT') {
            const isSelected = input.checked;
            if (isAvailable) {
              input.removeAttribute('disabled');
              input.classList.remove('disabled');
              const label = fieldset.querySelector(`label[for="${input.id}"]`);
              label?.classList.remove('disabled');
            } else if (!isSelected) {
              input.setAttribute('disabled', 'disabled');
              input.classList.add('disabled');
              const label = fieldset.querySelector(`label[for="${input.id}"]`);
              label?.classList.add('disabled');
            }
          } else if (input.tagName === 'OPTION') {
            if (isAvailable) {
              input.removeAttribute('disabled');
              input.classList.remove('disabled');
            } else if (!input.selected) {
              input.setAttribute('disabled', 'disabled');
              input.classList.add('disabled');
            }
          }
        }

        updateAvailableOptions() {
          if (!this.variantsData?.variants) return;

          const allVariants = this.variantsData.variants;
          const attributes = this.variantsData.attributes || [];
          const selectedValues = this.selectedValues || [];

          // Only block options if variantIndex has been populated
          const shouldCheckIndex = this.state.variantIndex.size > 0;

          attributes.forEach((attribute, attributeIndex) => {
            const fieldset = this.querySelector(`[data-attribute-index="${attributeIndex}"]`);
            if (!fieldset) return;

            const inputs = fieldset.querySelectorAll('input[type="radio"], select option');

            inputs.forEach((input) => {
              const value = input.value;
              if (!value) return;

              let isAvailable = this.isVariantAvailable(allVariants, attributeIndex, value, selectedValues);

              // If variantIndex is populated, check if product exists for this combination
              if (shouldCheckIndex && isAvailable) {
                const testValues = [...selectedValues];
                testValues[attributeIndex] = value;

                // Normalize test values
                const normalizedTestValues = this.normalizeVariant(testValues, attributes.length);

                const variantKey = this.createVariantKey(normalizedTestValues);
                isAvailable = this.state.variantIndex.has(variantKey);
              }

              this.updateInputDisabledState(input, isAvailable, fieldset);
            });
          });
        }

        async updateCurrentProductVariantData() {
          // Update variant data display without changing product
          if (!this.variantsData) return;

          // Update the metafield data with current selected values
          const metafieldScript = this.querySelector('[data-variants-metafield]');
          if (metafieldScript) {
            this.variantsData.currentVariantData = [...this.selectedValues];
            metafieldScript.textContent = JSON.stringify(this.variantsData);
          }

          // Get current product URL
          let currentProductUrl = this.dataset.url;
          if (!currentProductUrl && this.currentProductHandle) {
            currentProductUrl = `/products/${this.currentProductHandle}`;
          }
          if (!currentProductUrl) {
            currentProductUrl = window.location.pathname;
          }

          // Build option values string for product update
          const optionValues = this.selectedValues.join(',');

          // Load product with selected option values
          try {
            const requestUrl = `${currentProductUrl}?section_id=${this.dataset.section}&option_values=${encodeURIComponent(optionValues)}`;
            const response = await fetch(requestUrl);

            if (!response.ok) {
              console.error('Failed to fetch product with option values:', response.status);
              return;
            }

            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            // Find product-info element
            const productInfo = document.querySelector(`product-info[id^="MainProduct-${this.dataset.section}"]`);
            if (!productInfo) return;

            // Get new product-info from response
            const newProductInfo = doc.querySelector(`product-info[id^="MainProduct-${this.dataset.section}"]`);
            if (!newProductInfo) return;

            // Update product-info content
            productInfo.innerHTML = newProductInfo.innerHTML;

            // Trigger variant change events for proper form initialization
            const variantSelects = productInfo.querySelector('variant-selects [data-selected-variant]');
            if (variantSelects) {
              const variant = JSON.parse(variantSelects.innerHTML);
              if (variant) {
                document.dispatchEvent(
                    new CustomEvent('variant:changed', {
                      detail: {
                        variant: variant,
                      },
                    })
                );

                if (FoxTheme?.pubsub) {
                  FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, {
                    data: {
                      sectionId: this.dataset.section,
                      html: doc,
                      variant: variant,
                    },
                  });
                }
              }
            }

            // Update color swatch images after product update
            this.updateColorSwatchImages();
          } catch (error) {
            console.error('Error updating product with option values:', error);
          }
        }
      }
  );
}